import { FC } from 'react';
import styled from 'styled-components';
import { getAPRText, getDollarAmountText } from '../../../../../services/utils/FormatHelper';
import { theme } from '../../../../../styles/theme';
import { Typography } from '../../../../style';
import { ContractDataProps } from '../contract-modal/ContractDetails';
import { StyledRow } from './Style';

const FinancePaymentDetails: FC<ContractDataProps> = (props) => {
  return (
    <Wrapper data-testid='finance-payment-details-table'>
      <tbody>
        <StyledRow>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h5}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.wetAsphalt}
            >
              APR
            </Typography>
          </td>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h5}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.wetAsphalt}
            >
              Down Payment
            </Typography>
          </td>
        </StyledRow>
        <StyledRow>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.normal}
              color={theme.palette.grey}
            >
              {getAPRText(props.data.rate ? props.data.rate : 0)}
            </Typography>
          </td>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.dusty}
            >
              $&nbsp;
            </Typography>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.normal}
              color={theme.palette.grey}
            >
              {getDollarAmountText(props.data.driveOffAmount ? props.data.driveOffAmount : 0)}
            </Typography>
          </td>
        </StyledRow>
        <StyledRow>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h5}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.wetAsphalt}
            >
              Amount Financed
            </Typography>
          </td>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h5}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.wetAsphalt}
            >
              Balloon Amount
            </Typography>
          </td>
        </StyledRow>
        <StyledRow>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.dusty}
            >
              $&nbsp;
            </Typography>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.normal}
              color={theme.palette.grey}
            >
              {getDollarAmountText(props.data.amountFinanced ? props.data.amountFinanced : 0)}
            </Typography>
          </td>
          <td className='col-sm-6'>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.semibold}
              color={theme.palette.dusty}
            >
              $&nbsp;
            </Typography>
            <Typography
              size={theme.typography.h4}
              fontWeight={theme.typography.fontWeights.normal}
              color={theme.palette.grey}
            >
              {getDollarAmountText(props.data.balloonAmount ? props.data.balloonAmount : 0)}
            </Typography>
          </td>
        </StyledRow>
      </tbody>
    </Wrapper>
  );
};

export default FinancePaymentDetails;

const Wrapper = styled.table`
  padding-left: 20px;
  padding-right: 20px;
  display: flex;
  flex-direction: column;
  & tr {
    padding-top: 15px;
    line-height: 26px;
  }
  & tr:nth-child(2) {
    padding-top: 5px;
  }
  & tr:last-child {
    padding-top: 5px;
  }
`;
